import { useForm } from 'react-hook-form'
import { useBooking } from '../../context/BookingContext'
import { useAuth } from '../../context/AuthContext'
import { RiArrowLeftLine, RiArrowRightLine } from 'react-icons/ri'

export default function CustomerDetails() {
  const { booking, setCustomer, nextStep, prevStep } = useBooking()
  const { user } = useAuth()

  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      name:  booking.customer.name  || user?.name  || '',
      email: booking.customer.email || user?.email || '',
      phone: booking.customer.phone || user?.phone || '',
      notes: booking.customer.notes || '',
    },
  })

  const onSubmit = (data) => {
    setCustomer(data)
    nextStep()
  }

  return (
    <div>
      <h2 className="font-display text-salon-dark text-2xl font-bold mb-1">Your Details</h2>
      <p className="text-salon-muted font-body text-sm mb-6">Please confirm your contact information.</p>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="input-label">Full Name *</label>
            <input
              {...register('name', { required: 'Name is required' })}
              className="input-field"
              placeholder="Your full name"
            />
            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name.message}</p>}
          </div>

          <div>
            <label className="input-label">Phone Number *</label>
            <input
              {...register('phone', { required: 'Phone is required', pattern: { value: /^[6-9]\d{9}$/, message: 'Enter a valid 10-digit mobile number' } })}
              className="input-field"
              placeholder="+91 98765 43210"
              type="tel"
            />
            {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone.message}</p>}
          </div>
        </div>

        <div>
          <label className="input-label">Email Address *</label>
          <input
            {...register('email', { required: 'Email is required', pattern: { value: /^\S+@\S+\.\S+$/, message: 'Enter a valid email' } })}
            className="input-field"
            placeholder="you@example.com"
            type="email"
          />
          {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email.message}</p>}
        </div>

        <div>
          <label className="input-label">Special Requests / Notes</label>
          <textarea
            {...register('notes')}
            className="input-field min-h-[100px] resize-none"
            placeholder="Any allergies, preferences, or special requests..."
          />
        </div>

        <div className="flex justify-between pt-2">
          <button type="button" onClick={prevStep} className="btn-ghost"><RiArrowLeftLine /> Back</button>
          <button type="submit" className="btn-primary">Continue to Payment <RiArrowRightLine /></button>
        </div>
      </form>
    </div>
  )
}
